<template>
	<div id="devicePage" class="page-navbar">
			 <form class="searchBox" action="" onsubmit="return false;">
				<mt-search v-model="ipStr" @keyup.native.enter="search" placeholder="请输入IP地址或设备名称、设备型号进行搜索"></mt-search>
			</form>
			<div class="listCont" v-for="item in deviceList">
				<div class="oneList">
					<div class="listL">
						<div class="deviceImg" :class="item.type"></div>
						<div class="deviceLink">
								<div :class="[item.workSheetStatus==2?'deviceLink01 onlyRead':'deviceLink01']" @click="linkTo('worksheet',item,0)">
									<div :class="statusCls[item.workSheetStatus]"></div>
									<div class="lImg"></div>
								</div>
								<div :class="[item.monitorStatus==2?'deviceLink01 onlyRead':'deviceLink01']" @click="linkTo('monitorDetail',item,1)">
									<div :class="statusCls[item.monitorStatus]"></div>
									<div class="rImg"></div>
								</div>
						</div>
					</div>
					<div class="listR">
						<div class="contMes">
							<div class="mesTit">设备名称：</div>
							<div class="mes">{{item.deviceName}}</div>
						</div>
						<div class="contMes">
							<div class="mesTit">设备型号：</div>
							<div class="mes">{{item.deviceNum}}</div>
						</div>
						<div class="contMes">
							<div class="mesTit">设备版本：</div>
							<div class="mes">{{item.deviceVersion}}</div>
						</div>
						<div class="contMes">
							<div class="mesTit">IP地址：</div>
							<div class="mes">{{item.ip}}</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="listCont" v-for="item in serverList">
				<div class="oneList">
					<div class="listL">
						<div class="deviceImg service"></div>
						<div class="deviceLink">
								<div :class="[item.workSheetStatus==2?'deviceLink01 onlyRead':'deviceLink01']" @click="linkTo('worksheet',item,0)">
									<div :class="statusCls[item.workSheetStatus]"></div>
									<div class="lImg"></div>
								</div>
								<div :class="[item.monitorStatus==2?'deviceLink01 onlyRead':'deviceLink01']" @click="linkTo('monitorDetail',item,1)">
									<div :class="statusCls[item.monitorStatus]"></div>
									<div class="rImg"></div>
								</div>
						</div>
					</div>
					<div class="listR">
						<div class="contMes">
							<div class="mesTit">设备名称：</div>
							<div class="mes">{{item.hostName}}</div>
						</div>
						<div class="contMes">
							<div class="mesTit">设备型号：</div>
							<div class="mes">{{item.deviceModel}}</div>
						</div>
						<div class="contMes">
							<div class="mesTit">设备版本：</div>
							<div class="mes">{{item.iloFW}}</div>
						</div>
						<div class="contMes">
							<div class="mesTit">IP地址：</div>
							<div class="mes">{{item.ip}}</div>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	export default{
		name:'WcDevice',
		data(){
			return {
				statusCls:['rCir','lCir','grayCir'],
				ipStr:'',
				typeMap:{"0":'router',"00":"routerRe","1":"switches","11":"switchesRe","2":"wifi","3":"security","33":"securityRe","4":"firewall"},
				deviceList:[
					/*{workSheetStatus:1,monitorStatus:1,type:'switches',deviceName:'AIIB-BGW-ACCESS-Treading',deviceNum:"S5130-28S-HPWR-EI",ip:'10.30.15.99'},
					{workSheetStatus:2,monitorStatus:2,type:'switches',deviceName:'WW-JR-21A1-S5154-POE-01',deviceNum:"S6800-54HF",ip:'10.30.15.20'},
					{type:'router',deviceName:'WW-JR-03A1-S5154-POE-01',deviceNum:"S5130-52S-PWR-EI",ip:'10.30.15.3'},
					{type:'routerRe',deviceName:'WW-JR-17C1-S5154-POE-01',deviceNum:"S5130-52S-PWR-EI",ip:'10.30.15.19'},
					{type:'router',deviceName:'BGW-route1',deviceNum:"SR6602-X",ip:'10.30.16.22'},
					{type:'wifi',deviceName:'BGW-AC-Slave',deviceNum:"LSU3WCMD0",ip:'10.18.0.2'},
					{type:'security',deviceName:'BGW-FW',deviceNum:"SecPath F1070",ip:'10.30.16.6'},
					{type:'switchesRe',deviceName:'WW-JR-07A1-S5154-POE-01',deviceNum:"S5130-52S-PWR-EI",ip:'10.30.15.6'},
					{type:'switches',deviceName:'WW-JR-20A1-S5154-POE-01-A',deviceNum:"S5130-52S-PWR-EI",ip:'10.30.15.17'},
					{type:'switches',deviceName:'BGW-core-irf',deviceNum:"S10506",ip:'10.30.15.254'}*/
				],
				serverList:[]
			}
		},
		filters:{
			capitalize(value){
				if(value=="security") return 'security';
				if(value=="securityRe") return 'securityRe';
				if(value=="router") return 'router';
				if(value=="routerRe") return 'routerRe';
				if(value=="switches") return 'switches';
				if(value=="switchesRe") return 'switchesRe';
				if(value=="wifi") return 'wifi';
				if(value=="firewall") return 'firewall';
				if(value=="save") return 'save';
				if(value=="service") return 'service';
			}
		},
		methods:{
			/* classObj:function(){
				
			} */
			linkTo(page,param,index){
				var url=`/${page}?deviceIp=${param.ip}`;
				if(index==1){
					url=`/${page}?ip=${param.ip}&resource=0&isDevice=1&type=${param.deviceType}`;
				}
				if(this.ipStr.trim()){
					url+='&str='+this.ipStr.trim()
				}
				this.$router.push(url)
			},
			onSwipeLeft(){
				console.log("向左滑动");
			},
			onSwipeRight(){
				console.log("向右划动");
			},
			getDeviceList(){
				_api('_device','.code',{params:{mark:'devicesList',ipStr:this.ipStr.trim()}},res=>{
					this.deviceList=[];
					this.serverList=[];
					if(res.data&&res.data.devList){
						res.data.devList.forEach(item=>{
							this.deviceList.push({
								type:item.irf?this.typeMap[item.devCateType+""+item.devCateType]:this.typeMap[item.devCateType],
								deviceName:item.devName,
								deviceNum:item.devModel,
								deviceVersion:item.devVersion,
								ip:item.devIpAddr,
								workSheetStatus:item.workSheetStatus,
								monitorStatus:item.monitorStatus,
								deviceType:item.deviceType
							})
						})
					}
					if(res.data&&res.data.serverList){
						this.serverList=res.data.serverList
					}
				},err=>{
					
				})
			},
			search(){
				this.getDeviceList();
			},
		},
		mounted(){
			if(this.$route.query.str){
				this.ipStr=this.$route.query.str
			}
			this.getDeviceList();
		},
		computed:{
			/* classObj:function(){
				
			} */
		},
		
	}
</script>

<style>
	#devicePage .mint-search-list{
		display: none;
	}
</style>
<style scoped="scoped">
	body{
		width: 100%;
		height: 100%;
		background-size: 100% 100%;
	}
	
	#devicePage .searchBox{
		height: 55px;
	}
	#devicePage .listCont{
		width: 100%;
		height: auto;
		padding: 0 10px;
		box-sizing: border-box;
	}
	#devicePage .oneList{
		height: 120px;
		background: #FFFFFF;
		box-shadow: 2px 2px 10px #E1E1E1;
		padding: 10px;
		display: flex;
		margin-bottom: 10px;
	}
	#devicePage .listL{
		width: 30%;
		border-right: 1px solid #E8E8E8;
	}
	#devicePage .listR{
		width: 70%;
	}
	#devicePage .deviceImg{
		width: 70px;
		height: 70px;
		background: red;
		border-radius: 70px;
		margin-left: 10px;
	}
	#devicePage .deviceLink{
		display: flex;
		justify-content: space-between;
		height: 50px;
		padding: 0 5px;
		width: 80px;
	}
	#devicePage .deviceLink01{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	#devicePage .lCir{
		width: 10px;
		height: 10px;
		background: red;
		border-radius: 10px;
		margin-right: 3px;
	}
	#devicePage .rCir{
		width: 10px;
		height: 10px;
		background: #00E707;
		border-radius: 10px;
		margin-right: 3px;
	}
	#devicePage .grayCir{
		width: 10px;
		height: 10px;
		background: gray;
		border-radius: 10px;
		margin-right: 3px;
	}
	#devicePage .lImg{
		width: 12px;
		height: 18px;
		background: url(../../assets/images/device_work.png);
		background-size: 12px 18px;
	}
	#devicePage .rImg{
		width: 18px;
		height: 16px;
		background: url(../../assets/images/device_monitor.png);
		background-size:18px 16px;
	}
	#devicePage .contMes{
		height: 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 0 0 10px;
	}
	#devicePage .mesTit{
		color: #858585;
		width: 80px;
		min-width: 80px;
	}
	#devicePage .mes{
		color: #494949;
		overflow: hidden;
		/* white-space: nowrap;
		text-overflow: ellipsis; */
		text-align: right;
	}
	#devicePage .security{
		background: url(../../assets/images/security.png);
		background-size: 70px 70px;
	}
	#devicePage .securityRe{
		background: url(../../assets/images/securityRe.png);
		background-size: 70px 70px;
	}
	#devicePage .router{
		background: url(../../assets/images/router.png);
		background-size: 70px 70px;
	}
	#devicePage .routerRe{
		background: url(../../assets/images/routerRe.png);
		background-size: 70px 70px;
	}
	#devicePage .switches{
		background: url(../../assets/images/switches.png);
		background-size: 70px 70px;
	}
	#devicePage .switchesRe{
		background: url(../../assets/images/switchesRe.png);
		background-size: 70px 70px;
	}
	#devicePage .wifi{
		background: url(../../assets/images/wifi.png);
		background-size: 70px 70px;
	}
	#devicePage .firewall{
		background: url(../../assets/images/firewall.png);
		background-size: 70px 70px;
	}
	#devicePage .save{
		background: url(../../assets/images/save.png);
		background-size: 70px 70px;
	}
	#devicePage .service{
		background: url(../../assets/images/service.png);
		background-size: 70px 70px;
	} 
	.onlyRead{
		pointer-events: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/device/WcDevice.vue